var PLANETARY_HEALTH_WORKSPACE_ID, Question, W, alt, exportComparison, exportInterventions, exportIsof, exportJustificationPromise, exportOutcomes, exportPlr, exportPopulation, exportQuestionAndRecommendation, exportYesNoTextField, get, getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel, getConclusionsContentPromise, getContentWithReferencesPromise, getEtdPrintout, getQuestionSectionsContentPromise, getRecommendationDirectionAndStrength, getRecommendationMetadata, getRecommendationMetadataOrUndefined, getRecommendationTextContent, getRemarksContent, getSimplifiedGradeCertaintyOfEvidence, getSofPrintout, mediator, picoDataMapper, prepareCodes, processReferencesForExport, renderEditorValue, renderEditorValueFromRecommendationMetadata, sanitizeReference, _ref, _ref1;

get = require('lodash').get;

_ref = require('lib/services/covid_exporter/utils'), exportIsof = _ref.exportIsof, exportJustificationPromise = _ref.exportJustificationPromise, exportYesNoTextField = _ref.exportYesNoTextField, getAssessmentSectionsPromises = _ref.getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel = _ref.getCertaintyOfEvidenceAndLabel, getSimplifiedGradeCertaintyOfEvidence = _ref.getSimplifiedGradeCertaintyOfEvidence, getConclusionsContentPromise = _ref.getConclusionsContentPromise, getEtdPrintout = _ref.getEtdPrintout, getQuestionSectionsContentPromise = _ref.getQuestionSectionsContentPromise, getRecommendationDirectionAndStrength = _ref.getRecommendationDirectionAndStrength, getRecommendationMetadata = _ref.getRecommendationMetadata, getRecommendationMetadataOrUndefined = _ref.getRecommendationMetadataOrUndefined, getRecommendationTextContent = _ref.getRecommendationTextContent, getRemarksContent = _ref.getRemarksContent, getSofPrintout = _ref.getSofPrintout, exportPlr = _ref.exportPlr, renderEditorValue = _ref.renderEditorValue, renderEditorValueFromRecommendationMetadata = _ref.renderEditorValueFromRecommendationMetadata, prepareCodes = _ref.prepareCodes;

PLANETARY_HEALTH_WORKSPACE_ID = require('lib/planetary_health_extraction_helper').PLANETARY_HEALTH_WORKSPACE_ID;

getContentWithReferencesPromise = require('lib/services/document_sections_exporter/utils').getContentWithReferencesPromise;

mediator = require('mediator');

alt = require('alt');

_ref1 = require('lib/references_utils'), processReferencesForExport = _ref1.processReferencesForExport, sanitizeReference = _ref1.sanitizeReference;

Question = require('models/question');

W = require('when/when');

picoDataMapper = function(key, type) {
  return function(pico, idx) {
    if (!pico.selected) {
      return null;
    }
    return {
      '@id': "" + key + idx,
      '@type': type,
      name: pico.value,
      codes: prepareCodes(pico.codes)
    };
  };
};

exportComparison = function(question, typePrefix) {
  var comparator, _ref2, _ref3;
  if (mediator.services.switches.isServerSwitchOn('chronicPainFeatures')) {
    comparator = (question.picoData || {}).comparator;
    comparator = (comparator || []).map(picoDataMapper('_:comp', "" + typePrefix + "Comparator"));
    return _.compact(comparator);
  }
  if (question.type === 'diagnostic' && question['comparatorTestPresent']) {
    return [
      {
        '@id': '_:comp1',
        '@type': "" + typePrefix + "Comparator",
        'name': question['comparatorTest'],
        'codes': prepareCodes((_ref2 = get(question, 'codes.comparatorTest')) != null ? _ref2 : {})
      }
    ];
  } else if (question.type === 'diagnostic') {
    return null;
  } else {
    return [
      {
        '@id': '_:comp1',
        '@type': "" + typePrefix + "Comparator",
        'name': question['comparison'],
        'codes': prepareCodes((_ref3 = get(question, 'codes.comparison')) != null ? _ref3 : {})
      }
    ];
  }
};

exportInterventions = function(question, typePrefix) {
  var intervention, _ref2, _ref3;
  if (mediator.services.switches.isServerSwitchOn('chronicPainFeatures')) {
    intervention = (question.picoData || {}).intervention;
    return _.compact((intervention || []).map(picoDataMapper('_:int', "" + typePrefix + "Intervention")));
  }
  if (question.type === 'diagnostic') {
    return [
      {
        '@id': '_:int1',
        '@type': "" + typePrefix + "Intervention",
        'name': question['indexTest'],
        'codes': prepareCodes((_ref2 = get(question, 'codes.indexTest')) != null ? _ref2 : {})
      }
    ];
  } else {
    return [
      {
        '@id': '_:int1',
        '@type': "" + typePrefix + "Intervention",
        'name': question['intervention'],
        'codes': prepareCodes((_ref3 = get(question, 'codes.intervention')) != null ? _ref3 : {})
      }
    ];
  }
};

exportPopulation = function(question, recommendation, typePrefix) {
  var attachments, population, setting, _ref2;
  attachments = get(recommendation, '_attachments', {});
  setting = renderEditorValue(get(recommendation, 'templateData.question.sections.setting.content'), attachments);
  if (!setting) {
    setting = question['settings'];
  }
  if (!setting) {
    setting = void 0;
  }
  if (mediator.services.switches.isServerSwitchOn('chronicPainFeatures')) {
    population = (question.picoData || {}).population;
    return _.compact((population || []).map(picoDataMapper('_:pop', "" + typePrefix + "Population")));
  } else {
    return [
      {
        '@id': '_:pop1',
        '@type': "" + typePrefix + "Population",
        'ages': _.reject(getRecommendationMetadata(recommendation, 'age'), function(v) {
          return v === 'any';
        }),
        'codes': prepareCodes((_ref2 = get(question, 'codes.population')) != null ? _ref2 : {}),
        'description': question['healthProblemOrPopulation'],
        'setting': setting
      }
    ];
  }
};

exportOutcomes = function(question, typePrefix) {
  var outcome;
  outcome = (question.picoData || {}).outcome;
  return _.compact((outcome || []).map(picoDataMapper('_:out', "" + typePrefix + "Outcome")));
};

exportQuestionAndRecommendation = function(question, recommendations, projectId) {
  var assessmentPromises, attachmentSource, attachments, conclusionsPromise, isDiagnostic, isGps, justificationPromise, projectName, questionModel, questionSectionsPromise, recommendation, recommendationContent, recommendationId, recommendationTextPromise, relatedEvidenceIds, relatedEvidenceProfiles, remarksContent, remarksPromise, typePrefix;
  projectName = mediator.projects.get(projectId).get('name');
  questionModel = new Question(question);
  isDiagnostic = question['type'] === 'diagnostic';
  isGps = question['type'] === 'good-practice-statement';
  recommendationId = _.first(question['recommendationIds']);
  recommendation = get(recommendations, recommendationId);
  if (!recommendation) {
    return W.resolve();
  }
  attachments = get(recommendation, '_attachments', {});
  attachmentSource = {
    dbName: projectId,
    docId: recommendationId
  };
  remarksContent = getRemarksContent(recommendation);
  remarksPromise = getContentWithReferencesPromise("remarks_" + recommendationId, remarksContent, '', attachments, attachmentSource);
  recommendationContent = getRecommendationTextContent(recommendation, isGps);
  recommendationTextPromise = getContentWithReferencesPromise("recommendation_" + recommendationId, recommendationContent, '', attachments, attachmentSource);
  relatedEvidenceIds = get(recommendation, 'templateData.relatedEvidenceIds');
  relatedEvidenceProfiles = (relatedEvidenceIds != null ? relatedEvidenceIds.length : void 0) ? relatedEvidenceIds.map(function(id) {
    var evidence, profile, _ref2;
    evidence = alt.stores.PublicationPlatformStore.getState().getIn(['common', 'questions', id], Immutable.Map()).toJS();
    profile = new Question(evidence);
    if (!((_ref2 = profile.get('outcomes')) != null ? _ref2.length : void 0)) {
      return null;
    }
    return {
      name: profile.get('question'),
      isofData: exportIsof(profile, projectName)
    };
  }) : [];
  typePrefix = mediator.services.switches.isServerSwitchOn('chronicPainFeatures') ? 'ChronicPain' : 'WHO';
  assessmentPromises = getAssessmentSectionsPromises(recommendation);
  justificationPromise = exportJustificationPromise(recommendation);
  conclusionsPromise = getConclusionsContentPromise(recommendation, ['recommendation', 'goodPracticeStatement']);
  questionSectionsPromise = getQuestionSectionsContentPromise(recommendation);
  return W.all([recommendationTextPromise, remarksPromise, assessmentPromises, justificationPromise, conclusionsPromise, questionSectionsPromise]).then(function(_arg) {
    var allReferenceIds, assessment, certaintyOfEvidence, coexistingConditions, conclusions, etdPrintoutPromise, fullReferencesData, gradeCertaintyOfEvidenceLabel, interventionDescription, isofData, justification, plainLanguageSummary, questionSections, recommendationContent, recommendationDirection, recommendationIntentKey, recommendationStrength, recommendationText, recommendationValue, referenceIds, references, referencesFromTablesIds, remarks, remarksText, sofPrintoutPromise, _ref2, _ref3;
    recommendationContent = _arg[0], remarks = _arg[1], assessment = _arg[2], justification = _arg[3], conclusions = _arg[4], questionSections = _arg[5];
    _ref2 = getRecommendationDirectionAndStrength(recommendation), recommendationDirection = _ref2[0], recommendationStrength = _ref2[1], recommendationValue = _ref2[2];
    if (justification != null) {
      conclusions['sections']['justification'] = justification;
    }
    interventionDescription = _.compact([question['intervention'], question['comparison']]).join(', ');
    coexistingConditions = _.chain(getRecommendationMetadata(recommendation, 'coexistingCondition', '')[0].split(';')).map(function(value) {
      return _.str.capitalize(value.trim());
    }).compact().value();
    _ref3 = getCertaintyOfEvidenceAndLabel(recommendation), certaintyOfEvidence = _ref3[0], gradeCertaintyOfEvidenceLabel = _ref3[1];
    isofData = exportIsof(questionModel, projectName);
    plainLanguageSummary = _.reject(getRecommendationMetadata(recommendation, 'plainLanguageSummary'), function(plr) {
      return _.isEmpty(plr.link);
    });
    etdPrintoutPromise = getEtdPrintout(projectId, questionModel, recommendationId);
    sofPrintoutPromise = getSofPrintout(questionModel);
    recommendationText = recommendationContent.htmlContent;
    remarksText = remarks.htmlContent;
    references = _.map(_.extend({}, (assessment != null ? assessment.sections : void 0) || {}, (conclusions != null ? conclusions.sections : void 0) || {}), function(section) {
      return section.referenceData || {
        references: [],
        referencesFromTables: [],
        fullReferencesData: []
      };
    }).concat([_.omit(recommendationContent, 'htmlContent'), _.omit(remarks, 'htmlContent')]);
    referenceIds = _.chain(references).pluck('references').flatten().compact().uniq().value();
    referencesFromTablesIds = _.chain(references).pluck('referencesFromTables').flatten().compact().uniq().value();
    allReferenceIds = _.union(referenceIds, referencesFromTablesIds);
    fullReferencesData = _.chain(references).pluck('fullReferencesData').flatten().compact().map(function(ref) {
      return _.map(_.values(ref), sanitizeReference);
    }).flatten().value();
    references = processReferencesForExport(allReferenceIds, fullReferencesData);
    recommendationIntentKey = mediator.activeWorkspace === PLANETARY_HEALTH_WORKSPACE_ID ? 'recommendationModule' : 'recommendationIntent';
    return W.all([etdPrintoutPromise, sofPrintoutPromise]).then(function(_arg1) {
      var etdPrintout, sofPrintout, _ref4, _ref5, _ref6, _ref7;
      etdPrintout = _arg1[0], sofPrintout = _arg1[1];
      return {
        '@id': question['_id'],
        '@type': "" + typePrefix + "Recommendation",
        'adapted': getRecommendationMetadata(recommendation, 'adapted', false)[0],
        'adolopment': _.union(['all'], getRecommendationMetadata(recommendation, 'adolopment')),
        'age': _.union(['all'], getRecommendationMetadata(recommendation, 'age')),
        'agreeRexDomains': getRecommendationMetadata(recommendation, 'agreeRexDomains'),
        "authors": renderEditorValueFromRecommendationMetadata(recommendation, 'authors'),
        'carePhase': getRecommendationMetadata(recommendation, 'carePhase'),
        'certaintyOfEvidence': _.union(['all'], getRecommendationMetadata(recommendation, 'certaintyOfEvidence')),
        'certaintyOfEvidenceTextInput': renderEditorValueFromRecommendationMetadata(recommendation, 'certaintyOfEvidenceTextInput'),
        'clinicalDomain': getRecommendationMetadata(recommendation, 'clinicalDomain'),
        'clinicalSettings': getRecommendationMetadata(recommendation, 'clinicalSettings'),
        'coexistingCondition': coexistingConditions,
        'diagnostic': isDiagnostic,
        'diseaseCondition': getRecommendationMetadata(recommendation, 'diseaseCondition'),
        'equityItem2': exportYesNoTextField(getRecommendationMetadata(recommendation, 'equityItem2')),
        'etdPrintout': etdPrintout,
        'gps': isGps,
        'gradingEvidenceMethod': _.union(['all'], getRecommendationMetadata(recommendation, 'gradingEvidenceMethod')),
        'informal': getRecommendationMetadata(recommendation, 'informal', false)[0],
        'intendedPopulation': getRecommendationMetadata(recommendation, 'intendedPopulation'),
        'isofData': isofData,
        'patientPopulations': getRecommendationMetadata(recommendation, 'patientPopulations'),
        'plr': exportPlr(recommendation, isGps),
        'plainLanguageSummary': plainLanguageSummary,
        'planetaryHealth': getRecommendationMetadata(recommendation, 'planetaryHealth'),
        'publicationDate': getRecommendationMetadataOrUndefined(recommendation, 'publicationDate'),
        'recommendationIntent': _.union(['all'], getRecommendationMetadata(recommendation, recommendationIntentKey)),
        'recommendationStatus': getRecommendationMetadata(recommendation, 'recommendationStatus'),
        'references': (references || Immutable.List()).toJS(),
        'relatedEvidenceProfiles': relatedEvidenceProfiles,
        'reportedAsGPS': getRecommendationMetadata(recommendation, 'reportedAsGPS', false)[0],
        'research': getRecommendationMetadata(recommendation, 'research', false)[0],
        'sofPrintout': sofPrintout,
        'strengthOfRecommendation': _.union(['all'], getRecommendationMetadata(recommendation, 'strengthOfRecommendation')),
        'strengthOfRecommendationText': renderEditorValueFromRecommendationMetadata(recommendation, 'strengthOfRecommendationText'),
        'transformed': getRecommendationMetadata(recommendation, 'transformed', false)[0],
        'topic': getRecommendationMetadata(recommendation, 'topic'),
        'question': [
          {
            '@id': '_:q1',
            '@type': "" + typePrefix + "Question",
            'comparison': exportComparison(question, typePrefix),
            'gradeCertaintyOfEvidence': certaintyOfEvidence,
            'gradeCertaintyOfEvidenceSimplified': getSimplifiedGradeCertaintyOfEvidence(certaintyOfEvidence),
            'gradeCertaintyOfEvidenceLabel': gradeCertaintyOfEvidenceLabel,
            'intervention': exportInterventions(question, typePrefix),
            'interventionDescription': interventionDescription,
            'outcome': exportOutcomes(question, typePrefix),
            'perspective': (questionSections != null ? (_ref4 = questionSections.sections) != null ? (_ref5 = _ref4.perspective) != null ? _ref5.content : void 0 : void 0 : void 0) || '',
            'population': exportPopulation(question, recommendation, typePrefix),
            'populationDescription': question['healthProblemOrPopulation']
          }
        ],
        'recommendation': {
          'assessmentSummary': assessment,
          'coi': (questionSections != null ? (_ref6 = questionSections.sections) != null ? (_ref7 = _ref6.coi) != null ? _ref7.content : void 0 : void 0 : void 0) || '',
          'conclusions': conclusions,
          'direction': recommendationDirection,
          'recommendationValue': recommendationValue,
          'remarks': remarksText,
          'strength': recommendationStrength,
          'value': recommendationText
        }
      };
    });
  });
};

module.exports = exportQuestionAndRecommendation;
